import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plug, Check, Clock } from "lucide-react";
import api from "@/lib/api";
import { useT } from "@/i18n";

export default function Connectors() {
  const t = useT();
  const [connectors, setConnectors] = useState([]);

  useEffect(() => {
    api.get("/connectors").then(({ data }) => setConnectors(data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="flex items-center gap-2 font-display text-3xl font-extrabold tracking-tighter">
        <Plug className="h-6 w-6 text-brand" />{t("connectorsPage.title")}
      </h1>
      <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{t("connectorsPage.subtitle")}</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="connectors-grid">
        {connectors.map((c, i) => {
          const ready = c.status === "ready";
          return (
            <motion.div key={c.key} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, delay: i * 0.05 }}
              className="flex flex-col rounded-lg border border-border bg-card p-5 transition-transform hover:-translate-y-1" data-testid={`connector-${c.key}`}>
              <div className="flex items-center justify-between">
                <h3 className="font-display text-lg font-bold">{c.label}</h3>
                <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium ${ready ? "bg-success/10 text-success" : "bg-secondary text-muted-foreground"}`}>
                  {ready ? <Check className="h-3 w-3" /> : <Clock className="h-3 w-3" />}
                  {ready ? t("connectorsPage.statusReady") : t("connectorsPage.statusComingSoon")}
                </span>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{c.description}</p>
              <div className="mt-4 border-t border-border pt-3">
                <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{t("connectorsPage.protocol")}</p>
                <p className="mt-0.5 font-mono text-xs">{c.protocol}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
